<script>
  import Swal from 'sweetalert2';
  import {draftStore, project, thumbDraft, menu} from '../../store';
  import DraftService from '../../services/drafts';
  import {writable} from 'svelte/store';
  import {adminView} from '../../lib/admin/admin';
  import {MENU} from '@/types/common';
  let saving = writable(false);
  function showLoading() {
    Swal.fire({
      title: 'Please wait Saving now',
      didOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: () => !Swal.isLoading(),
      allowEscapeKey: () => !Swal.isLoading(),
      allowEnterKey: () => !Swal.isLoading()
    });
  }
  function saveNewProject() {
    saving.set(true);
    Swal.fire({
      title: 'Save Project',
      text: 'Future changes will autosave',
      input: 'text',
      showCancelButton: true
    }).then(result => {
      if (result.isConfirmed) {
        if (result.value == '') {
          return saveNewProject();
        }
        showLoading();
        const draftService = new DraftService();

        draftService.makeProject($draftStore.currentCloudDraftId, result.value).then(result => {
          saving.set(false);
          Swal.hideLoading();
          draftStore.markDraftAsProject(result.value);
          Swal.fire({
            title: 'Project Saved',
            icon: 'success',
            timer: 500,
            timerProgressBar: true
            //   showConfirmButton: false,
          });
        });
      }
    });
  }
  function updateProject() {
    if ($menu !== MENU.CLIPS) return;
    saving.set(true);
    let _project = JSON.parse(JSON.stringify($project));
    draftStore.updateDraft(_project, pName).then(result => {
      saving.set(false);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Project Saved',
        showConfirmButton: false,
        timer: 1000,
        toast: true
      });
    });
  }
  let pName = '';
  draftStore.subscribe(s => {
    pName = s.projectName;
  });
  thumbDraft.subscribe(s => {
    pName = s.projectName;
  });
</script>

<div class="mr-2 text-xs" use:adminView>
  <input type="text" bind:value={pName} />
  {#if $draftStore.isProject}
    <button class="btn" disabled={$saving} on:click={updateProject}>Save Update</button>
  {:else}
    <button class="btn" disabled={$saving} on:click={saveNewProject}>Save As New Project</button>
  {/if}
</div>

<style lang="postcss">
  .btn {
    @apply rounded-md bg-primary px-4 py-2 font-semibold text-white;
  }
</style>
